(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hg-order-tracking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hg-order-tracker')) {
    class HGOrderTracker extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.mode = 'order';
        this.savedValues = { order: '', phone: '' };
        this.requestVersion = 0;

        this.form = this.querySelector('.hgot-form');
        this.input = this.querySelector('input');
        this.label = this.querySelector('[data-label]');
        this.hint = this.querySelector('[data-hint]');
        this.symbol = this.querySelector('[data-symbol]');
        this.message = this.querySelector('.hgot-message');
        this.results = this.querySelector('.hgot-results');
        this.resultBody = this.querySelector('.hgot-results-body');
        this.submitButton = this.querySelector('.hgot-submit');
        this.buttonLabel = this.querySelector('[data-button-label]');
        this.originalButtonLabel = this.buttonLabel.textContent;

        this.querySelectorAll('[data-mode]').forEach((button) => {
          button.addEventListener('click', () => {
            this.changeMode(button.dataset.mode);
          });
        });

        this.input.addEventListener('input', () => {
          this.input.removeAttribute('aria-invalid');
          this.message.hidden = true;
        });

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.search();
        });
      }

      disconnectedCallback() {
        this.requestVersion += 1;
        if (this.controller) this.controller.abort();
        if (this.submitButton) this.setLoading(false);
      }

      changeMode(mode) {
        if (mode === this.mode) return;

        this.savedValues[this.mode] = this.input.value;
        this.requestVersion += 1;
        if (this.controller) this.controller.abort();

        this.mode = mode;
        this.setLoading(false);
        this.message.hidden = true;
        this.results.hidden = true;
        this.resultBody.replaceChildren();
        this.input.removeAttribute('aria-invalid');

        const phone = mode === 'phone';

        this.querySelectorAll('[data-mode]').forEach((button) => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.mode === mode)
          );
        });

        this.label.textContent = phone ? 'Phone number' : 'Order number';
        this.input.name = phone ? 'phone_number' : 'order_number';
        this.input.type = phone ? 'tel' : 'text';
        this.input.inputMode = phone ? 'tel' : 'text';
        this.input.autocomplete = phone ? 'tel' : 'off';
        this.input.placeholder = phone
          ? 'Enter your phone number'
          : 'Enter your order number';
        this.input.value = this.savedValues[mode];
        this.symbol.textContent = phone ? '+' : '#';
        this.hint.textContent = phone
          ? 'Use the Bangladesh mobile number entered at checkout.'
          : 'Find this in your order confirmation email or SMS.';

        this.input.focus();
      }

      normalizeDigits(value) {
        return value.replace(/[০-৯]/g, (digit) =>
          String('০১২৩৪৫৬৭৮৯'.indexOf(digit))
        );
      }

      normalizePhone(value) {
        let phone = this.normalizeDigits(value)
          .trim()
          .replace(/[\s().-]/g, '');

        if (phone.startsWith('00880')) {
          phone = phone.slice(4);
        } else if (phone.startsWith('+880')) {
          phone = phone.slice(3);
        } else if (phone.startsWith('880')) {
          phone = phone.slice(2);
        }

        return phone;
      }

      showMessage(text, invalid) {
        this.message.textContent = text;
        this.message.hidden = false;

        if (invalid) {
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
        }
      }

      setLoading(loading) {
        this.setAttribute('aria-busy', String(loading));
        this.submitButton.disabled = loading;
        this.input.readOnly = loading;
        this.buttonLabel.textContent = loading
          ? 'Finding your order...'
          : this.originalButtonLabel;
      }

      cleanResponse(html, baseURL) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        parsed.querySelectorAll(
          'script,style,iframe,object,embed,link,meta,base,form,input,button,textarea,select,svg,math,template'
        ).forEach((element) => element.remove());

        const allowedTags = new Set([
          'DIV', 'SPAN', 'P', 'BR', 'HR', 'STRONG', 'B', 'EM', 'I',
          'SMALL', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL',
          'LI', 'TABLE', 'THEAD', 'TBODY', 'TFOOT', 'TR', 'TH', 'TD',
          'CAPTION', 'A', 'SECTION', 'ARTICLE', 'DL', 'DT', 'DD'
        ]);

        Array.from(parsed.body.querySelectorAll('*')).forEach((element) => {
          if (!allowedTags.has(element.tagName)) {
            element.replaceWith(...element.childNodes);
            return;
          }

          const href = element.getAttribute('href');
          const colspan = element.getAttribute('colspan');
          const rowspan = element.getAttribute('rowspan');

          Array.from(element.attributes).forEach((attribute) => {
            element.removeAttribute(attribute.name);
          });

          if (element.tagName === 'A' && href) {
            try {
              const url = new URL(href, baseURL);
              if (url.protocol === 'https:' || url.protocol === 'http:') {
                element.href = url.href;
                element.target = '_blank';
                element.rel = 'noopener noreferrer';
              }
            } catch (error) {
              // Leave invalid links as plain text.
            }
          }

          if (element.tagName === 'TD' || element.tagName === 'TH') {
            if (/^[1-9]\d?$/.test(colspan || '')) {
              element.setAttribute('colspan', colspan);
            }
            if (/^[1-9]\d?$/.test(rowspan || '')) {
              element.setAttribute('rowspan', rowspan);
            }
          }
        });

        const fragment = document.createDocumentFragment();
        while (parsed.body.firstChild) {
          fragment.appendChild(parsed.body.firstChild);
        }
        return fragment;
      }

      async search() {
        if (this.submitButton.disabled) return;

        this.input.removeAttribute('aria-invalid');
        this.message.hidden = true;
        this.results.hidden = true;
        this.resultBody.replaceChildren();

        let value = this.normalizeDigits(this.input.value);

        if (this.mode === 'phone') {
          value = this.normalizePhone(value);
          if (!/^01[3-9]\d{8}$/.test(value)) {
            this.showMessage(
              'Please enter a valid Bangladesh mobile number, such as 01712345678.',
              true
            );
            return;
          }
        } else {
          value = value.replace(/[\s#]/g, '');
          if (!value) {
            this.showMessage('Please enter your order number.', true);
            return;
          }
        }

        const version = ++this.requestVersion;
        this.controller = new AbortController();
        const controller = this.controller;
        let timedOut = false;

        const timeout = window.setTimeout(() => {
          timedOut = true;
          controller.abort();
        }, 20000);

        this.setLoading(true);

        try {
          const endpoint = new URL(
            this.dataset.endpoint || '/apps/order-track/',
            window.location.origin
          );

          if (!['https:', 'http:'].includes(endpoint.protocol)) {
            throw new Error('Invalid tracking endpoint');
          }

          const body = new URLSearchParams();
          body.set(
            this.mode === 'phone' ? 'phone_number' : 'order_number',
            value
          );

          const response = await fetch(endpoint.href, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
              'Accept': 'text/html'
            },
            body: body.toString(),
            credentials: 'same-origin',
            cache: 'no-store',
            signal: controller.signal
          });

          if (!response.ok) {
            throw new Error('Tracking request failed');
          }

          const html = await response.text();

          if (version !== this.requestVersion || !this.isConnected) return;

          if (!html.trim()) {
            this.showMessage(
              'No result was returned. Check your details and try again.'
            );
            return;
          }

          if ((response.headers.get('content-type') || '').includes('application/json')) {
            throw new Error('Expected an HTML tracking response');
          }

          const content = this.cleanResponse(
            html,
            response.url || endpoint.href
          );

          if (!content.textContent.trim()) {
            this.showMessage(
              'No order details were returned. Please check your details or contact us.'
            );
            return;
          }

          this.resultBody.replaceChildren(content);
          this.results.hidden = false;
          this.showMessage('Search complete. Your results are below.');
          this.querySelector('.hgot-results-heading h3').focus({
            preventScroll: true
          });
          this.results.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth',
            block: 'nearest'
          });
        } catch (error) {
          if (version !== this.requestVersion || !this.isConnected) return;
          if (error.name === 'AbortError' && !timedOut) return;

          this.showMessage(
            timedOut
              ? 'The request took too long. Please try again.'
              : 'We could not load your order details. Please try again shortly or contact us.'
          );
        } finally {
          window.clearTimeout(timeout);
          if (version === this.requestVersion && this.isConnected) {
            this.setLoading(false);
          }
        }
      }
    }

    customElements.define('hg-order-tracker', HGOrderTracker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
